import './index.css'
import React, { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Chip from "@mui/material/Chip";
import TuneIcon from "@mui/icons-material/Tune";
import BadgeIndicator from "../../../common/BadgeIndicator";
import InputSearch from "../../../common/InputSearch";
import { useNavigate } from "react-router-dom";
import AddChip from "../../../common/ActionChip/AddChip";
import IndicatorChip from "../../../common/ActionChip/IndicatorChip";
import { NAMES_ES } from "../../../../assets/appConstants/constants";
import { ResetIcon } from "../../../common/Icons";
import { AreasFilterFormModel } from "../../../../models/area.model";


interface PrimaryMenuBarProps {
  handleOpenFilter: () => void
  setSearch: (filter: any) => void
  resetPrimaryFilter: () => void
  defaultSearchForm: AreasFilterFormModel
  selectedProject: string
  canEdit?: boolean
}

const PrimaryMenuBar: React.FC<PrimaryMenuBarProps> = ({ handleOpenFilter,
  setSearch, resetPrimaryFilter, defaultSearchForm, selectedProject, canEdit = false }) => {

  const navigate = useNavigate()
  const [appliedFilters, setAppliedFilters] = useState<{ 'key': string, 'value': string }[]>([])
  const [searchForm, setSearchForm] = useState<AreasFilterFormModel>(defaultSearchForm)

  const handleSearchForm = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchForm({
      ...searchForm,
      [event.target.name]: event.target.value
    });
  }

  useEffect(() => resetSearchForm(), [selectedProject])

  const resetSearchForm = () => {
    setSearchForm({
      ...defaultSearchForm
    })
  }

  const onSubmitSearch = () => {
    setSearch(searchForm)
    resetSearchForm()
  }

  const onResetSearch = () => {
    resetSearchForm()
  }

  const onResetFilters = () => {
    resetPrimaryFilter()
  }

  const showResetButton = () => {
    return appliedFilters.length === 1
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="areas-listing-primarybar-box" >
        <div className="areas-listing-primarybar-left">
          <span className="areas-listing-searchtkt">
            <InputSearch
              name='number'
              value={searchForm.name}
              placeholder="Nombre de Área"
              onChange={handleSearchForm}
              onSubmitSearch={onSubmitSearch}
              onResetSearch={onResetSearch}
            />
          </span>

          {(appliedFilters.length > 0) && (
            <div className="areas-listing-primarybar-left__sep"><p>|</p></div>
          )}

          {appliedFilters.map((item, index) => (
            <div key={index}>
              <IndicatorChip
                label={<span>
                  <span className="applied-filters__name">{NAMES_ES[item.key]}:</span> {item.value}
                </span>} />
            </div>
          ))
          }

          {showResetButton() && (
            <ResetIcon onClick={onResetFilters} className="applied-filters__reset" />
          )}
        </div>

        {(selectedProject) && (

          <div className="areas-listing-actions-toolbar__item-right">
            <BadgeIndicator
              element={(<Chip
                icon={<TuneIcon color="success" />}
                label="Filtros"
                clickable
                onClick={handleOpenFilter} />)
              }
              indicator={appliedFilters.length === 0 ? null : appliedFilters.length}
            />

            {canEdit && (
              <AddChip
                onClick={() => navigate('/area/create')}
                label='Nueva Área'
              />
            )}

          </div>
        )}

      </div>

    </React.Fragment>
  );
}

export default PrimaryMenuBar
